import { React } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';

export const CustomSnackbar = ({ snackbarId }) => {
  const { closeSnackbar } = useSnackbar();
  return (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={() => {
        closeSnackbar(snackbarId);
      }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};